import { Component, ViewEncapsulation } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UigNavigationService } from 'src/app/services/uig-navigation.service';
import { UigNavigationNode } from '../uig-navigation/uig-navigation-node-model';

@Component({
    selector: 'app-uig-category-navigation',
    templateUrl: './uig-category-navigation.component.html',
    styleUrls: ['./uig-category-navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCategoryNavigationComponent {

  node$: Observable<UigNavigationNode> = this.service.getNavigationNode(
    this.componentData.data$
  );

  data$: Observable<CmsNavigationComponent> = this.componentData.data$;

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: UigNavigationService
  ) {
  }

}
